export const releaseNotes = [
  {
    version: '1.2.0',
    date: '2026-06-13',
    items: [
      { type: 'feature', key: 'whatsNew.v1_2_0.whoIsOut' },
      { type: 'feature', key: 'whatsNew.v1_2_0.receptionRole' },
      { type: 'fix', key: 'whatsNew.v1_2_0.leaveBalance' },
      { type: 'feature', key: 'whatsNew.v1_2_0.changePassword' },
    ],
  },
];
